import Vue from 'vue'

const customerModule = {
    state: {
        customerList: [],
        partnerList: [],
        authorList: [],
        selectedCustomer: null
    },
    mutations: {
        SET_CUSTOMERS (state, newVal) {
            state.customerList = newVal
        },
        SET_PARTNER (state, newVal) {
            state.partnerList = newVal
        },
        SET_AUTHORS (state, newVal) {
            state.authorList = newVal
        },
        SET_SELECTED_CUSTOMER (state, newVal) {
            state.selectedCustomer = newVal
        }
    },
    getters: {
        getCustomers (state) {
            return state.customerList
        },
        getPartner (state) {
            return state.partnerList
        },
        getAuthors (state) {
            return state.authorList
        },
        selectedCustomer(state) {
            return state.selectedCustomer
        }
    },
    actions: {
        async FETCH_CUSTOMERS (ctx) {
            let result = await Vue.API.AmfRequest(
                'AddressController',
                'getAllCustomerForSelect'
            )
            ctx.commit('SET_CUSTOMERS', result.data)
        },
        async FETCH_PARTNER (ctx) {
            let result = await Vue.API.AmfRequest(
                'frechmann.Customer',
                'getPartnerForSelect'
            )
            ctx.commit('SET_PARTNER', result.data)
        },
        async FETCH_AUTHORS (ctx) {
            let result = await Vue.API.AmfRequest(
                'frechmann.Customer',
                'getAuthorForSelect'
            )
            ctx.commit('SET_AUTHORS', result.data)
        },
        async SAVE_CUSTOMER ({ dispatch, commit }) {
            await dispatch('customer/FETCH_CUSTOMERS')
        },
        setSelectedCustomer (state, newVal) {
            state.commit('SET_SELECTED_CUSTOMER', newVal.data)
        }
    }
}

export const state = customerModule.state
export const getters = customerModule.getters
export const mutations = customerModule.mutations
export const actions = customerModule.actions
